import { createApp } from "vue";
// import "./sentry";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";

// Imports
import { i18n } from "@/localization";
import "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";

// Import Vue plugins
import VueLazyload from "vue-lazyload";
import TextareaAutosize from "vue-textarea-autosize";
import VueToast from "vue-toast-notification";
import vueCountryRegionSelect from "vue-country-region-select";
import VAnimateCss from "v-animate-css";
import VueTippy from "vue-tippy";
import VueCookies from "vue-cookies";
import NavScroll from "navscroll";
import vClickOutside from "v-click-outside";
import VueClipboard from "vue-clipboard2";
import autoAnimate from "@formkit/auto-animate";
import vuescroll from "vue-scroll";
import { VueQueryPlugin } from "@tanstack/vue-query";
import PortalVue from "portal-vue";
// CSS
import "vue-toast-notification/dist/theme-sugar.css";
import "@/assets/scss/app.scss";
import "@/assets/svg/index";
import "vue-select/dist/vue-select.css";
import "tippy.js/dist/tippy.css";
import "vue-tel-input/vue-tel-input.css";
import "primeicons/primeicons.css";

import PrimeVue from "primevue/config";

// Create Vue event bus (consider using mitt or tiny-emitter instead in Vue 3)
import mitt from "mitt";
import { appTheme } from "@/ui";

export const bus = mitt();

// Create Vue app instance
const app = createApp(App);
// Register plugins
app.use(router);
app.use(store);
app.use(i18n);
app.use(NavScroll);
app.use(vueCountryRegionSelect);
app.use(VueToast, {
  position: window.outerWidth >= 1024 ? "bottom-right" : "top",
});
// @ts-ignore - Fix for VueLazyload type compatibility
app.use(VueLazyload);
app.use(TextareaAutosize);
app.use(VAnimateCss);
app.use(VueTippy, {
  directive: "tippy",
  defaultProps: {
    allowHTML: true,
  },
});
app.use(VueCookies);
app.use(vClickOutside);
app.use(VueClipboard);
app.use(vuescroll);
app.use(VueQueryPlugin);
app.use(PortalVue);

// Register directives
app.directive("auto-animate", (el, binding) => {
  autoAnimate(el, binding.value);
});

// Configure NavScroll defaults
NavScroll.setDefaults({
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  cancelable: true,
  onDone: false,
  onCancel: false,
  scrollX: false,
  scrollY: true,
});

// Add global properties
app.config.globalProperties.$errorResponse = {
  status: 0,
  errors: [],
};

// Add global data and methods
app.config.globalProperties.version = "v1.14.10";

app.use(PrimeVue, {
  locale: {
    dateFormat: "dd-mm-yy",
    firstDayOfWeek: 1,
    dayNames: ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"],
    dayNamesMin: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
    monthNames: ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"],
    monthNamesShort: ["Jan", "Feb", "Mrt", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
  },
  theme: {
    preset: appTheme,
    options: {
      darkModeSelector: ".app-dark",
    },
  },
});

// Mount the app
app.mount("#app");

export { app };
